import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
const faqs = [{
  q: '¿Esto funciona aunque yo nunca haya usado plantas medicinales?',
  a: 'Sí. El protocolo está diseñado para principiantes absolutas. Si puedes hervir agua y seguir instrucciones simples, puedes hacer esto.'
}, {
  q: '¿Es seguro para mujeres embarazadas o en lactancia?',
  a: 'Algunas plantas tienen contraindicaciones específicas en esos períodos. El material incluye una sección de advertencias claras. Siempre consulta con tu médico si estás en esa situación.'
}, {
  q: '¿Necesito comprar cosas especiales o caras?',
  a: 'No. El Checklist del Botiquín está diseñado para tu supermercado local. Todo por menos de $5 USD. Sin tiendas naturistas especializadas. Sin importaciones.'
}, {
  q: '¿Cuánto tiempo me tomará preparar los elixires?',
  a: 'Entre 5 y 10 minutos. Si puedes hervir agua, tienes el tiempo suficiente.'
}, {
  q: '¿Recibo algo físico por correo?',
  a: 'No. Es 100% digital. Recibes acceso inmediato en tu email — para que puedas empezar esta misma noche, sin esperar envíos.'
}, {
  q: '¿Qué pasa si compro y no me funciona?',
  a: 'Tienes 7 días completos para probarlo. Si no sientes diferencia real, escribes un email y recuperas tus $6.39 USD. Sin condiciones. Sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="px-6 py-10 max-w-3xl mx-auto" data-id="element-50">
      <FadeIn data-id="element-51">
        <h2 className="text-3xl font-serif font-bold text-center text-[#2D2A26] mb-8" data-id="element-52">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-3 mb-16" data-id="element-53">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-[#4A5D3A]/10 overflow-hidden transition-all duration-300" data-id="element-54">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-55">
                <span className="font-bold text-[#2D2A26] pr-4" data-id="element-56">{faq.q}</span>
                <ChevronDown className={`text-[#4A5D3A] transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-57" />
              </button>
              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-58">
                <p className="text-[#2D2A26]/80 leading-relaxed border-t border-gray-100 pt-4" data-id="element-59">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>

        {/* Final Emotional Close */}
        <div className="text-center space-y-8 max-w-2xl mx-auto" data-id="element-60">
          <div className="font-serif italic text-xl md:text-2xl text-[#4A5D3A] space-y-4 mb-8" data-id="element-61">
            <p data-id="element-62">Llevas demasiado tiempo cargando el peso de todo y de todos.</p>
            <p data-id="element-63">
              Mereces una noche en que tu mente finalmente te deje descansar.
            </p>
            <p className="font-bold not-italic text-[#9B4F2B]" data-id="element-64">
              Por $6.39 USD — hoy — eso puede cambiar.
            </p>
          </div>

          <CTAButton className="py-5" data-id="element-65">
            QUIERO MI RESCATE BOTÁNICO AHORA →
          </CTAButton>

          <p className="text-sm text-[#2D2A26]/60 font-medium tracking-wide pt-4" data-id="element-66">
            $6.39 USD · Acceso Instantáneo · Garantía 7 Días · Pago Seguro
          </p>
        </div>
      </FadeIn>
    </section>;
}